module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "d7e3859"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c5_r1#d6e1",
      "id": "d7e1"
    }
  }, [_c('b', [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e3909"
    }
  }, [_vm._v("My upbringing was midwestern conventional. Mom and Dad instilled the entrepreneurial spirit in me from an early age, and my political views were developed in an open and free atmosphere. A professor of history introduced me to Erik von Kuehnelt-Leddihn, who penned a minor classic, "), _c('i', [_vm._v("Liberty or Equality")]), _vm._v(", and to Russell Kirk, who authored the magisterial volume "), _c('i', [_vm._v("The Conservative Mind")]), _vm._v(". Political discussions were intense and eye-opening, but they were civil. I learned my friends and I could disagree with each other without being disagreeable—something that seems to be lacking in today’s Washington and indeed in many academic settings.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("ix")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4369"
    }
  }, [_vm._v("Coming to Washington was like arriving in another world, and my political and philosophical views were put to hard tests.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e4449"
    }
  }, [_vm._v("I was hooked—not on the politics of the place, but on the policy implementation of the governmental process. As a fellow at a then start-up think tank—later as a congressional staffer, a political aide to the secretary of defense, and the cofounder of what has become a major American institution—I relished the process of making laws, of giving real Americans, from Elmhurst and from La Jolla, a chance to experience the best of a free society.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e47810"
    }
  }, [_vm._v("My personal story underscores my frequent claim that “I am Washington’s greatest optimist.” Even today, I remain optimistic about our nation and our people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e49110"
    }
  }, [_vm._v("In an earlier book, with Doug Wilson, I called our fellow citizens back to first principles—to examine every proposal from government in the light of its ability to offer further opportunities to each of us and to bring us together as a people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e50510"
    }
  }, [_vm._v("In this book, my longtime friend and colleague Brian Tracy and I share our view of the real core of America, of American virtues and values, of those characteristics that we share and that are so noble and transforming both here and around the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e52510"
    }
  }, [_vm._v("We also share our view of things going on in America that we "), _c('i', [_vm._v("don’t ")]), _vm._v("like, not simply because they raise the deficit or delay our economic recovery or promote unemployment, but because they threaten to change the character of the American people in some very far-reaching and fundamental ways.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e54910"
    }
  }, [_vm._v("In his farewell remarks to his ministers in 1955, Winston Churchill said, “Man is spirit.” It is this spirit—this American Spirit—that Brian and I wish to preserve above all else. So long as it remains alive and kicking, we are confident that all the problems facing our nation will eventually sort themselves out satisfactorily. But should it ever be impaired or transformed, the brightest policy experts from the best think tanks won’t be able to arrest our inevitable decline.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("xi")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e58211"
    }
  }, [_vm._v("Whatever your views about marginal tax rates, the gold standard, debt-to-GDP ratios, the Laffer Curve, and similar policy issues, we hope you will come to share our belief that an American Spirit exists, that it defines us as a people, and that it deserves to be preserved.")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d7e60111"
    }
  }, [_vm._v("Edwin Feulner "), _c('br'), _vm._v(" February 2012")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781595553379_INT_0011_001",
      "src": "images/9781595553379_INT_0011_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e61111"
    }
  }, [_vm._v("When I was a young man, I set out on a journey of discovery that eventually took me to ninety countries on six continents. Having started with no money and no high school diploma, very early I began asking the question, "), _c('i', [_vm._v("Why is it that some people are more successful than others? ")]), _vm._v("This question saved my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e63811"
    }
  }, [_vm._v("As I grew and educated myself, I studied such philosophers as Socrates, Plato, and Aristotle, all of whom asked, "), _c('i', [_vm._v("How shall we live together in order to be happy? ")]), _vm._v("These early thinkers saw man as a social animal and gave careful consideration to the best way for society to be organized for the greatest good. This question led me into a lifelong quest to understand why some countries, and even parts of countries, are more successful than others the world over and throughout history.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e67111"
    }
  }, [_vm._v("By the time I was eighteen, I realized I did not want to live in a world where America, with its American ideals, was not the dominant power. The twin isms of socialism and communism were powerful influences in the world at that time, and they exerted an attraction on many people who should have known better. I concluded the American ideals of freedom, equality, individual rights, self-reliance, free enterprise, respect for private property, civil society, and the rule of law were the finest principles to which man has aspired in all human history.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("xii")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e70712"
    }
  }, [_vm._v("Today, millions of Americans are not clear about why the United States is the greatest country on earth and in all human history. Overseas, large numbers of people disapprove of America and the American way. Our aim in writing this book is to explain clearly what it means to be an American and why each American can be proud of being a citizen of this great country. We also want to explain to the world why Americans are an exceptional people, the “almost chosen” people of Abraham Lincoln. Every person reading these pages will emerge with a better understanding of the burden and the glory that come with being an American.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e74212"
    }
  }, [_vm._v("In a speech not long ago, the writer Midge Decter, who had switched from being a New York leftist hypercritical of America to a solidly pro-American conservative, explained what had caused her conversion. “I looked,” she said, “at the ideal upon which America was founded, and to which I am committed, and then compared these ideas with what I really believe was right and good for myself and my family. I then joined the conservatives. I decided to join the side I was on.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Feul_9781595553904_epub_c28_r1#d1",
      "id": "a1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e77312"
    }
  }, [_vm._v("In the pages ahead, you will learn what it is to be an American and why it is important “to join the side you are on.”")]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "d7e78312"
    }
  }, [_vm._v("Brian Tracy "), _c('br'), _vm._v(" February 2012")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed413e34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feul_9781595553904_epub_c6_r1.vue
// module id = 72
// module chunks = 0